<template>
  <div class="home-page">
    <div class="navi-bar">
      <div class="navi-bar-box">
        <div class="top">
          <div class="menu">

              <div class="botoom-item" @click="switchUi(1)">
                <span class="icon iconfont icon-chat"></span>
                <div v-show="unreadCount > 0" class="unread-text">
                  {{ unreadCount }}
                </div>
              </div>


              <div class="botoom-item" @click="switchUi(2)">
                <span class="icon iconfont icon-friend"></span>
              </div>

    
              <div class="botoom-item" @click="switchUi(3)">
                <span
                  class="icon iconfont icon-group"
                  style="font-size: 28px"
                ></span>
              </div>
            <div class="botoom-item" @click="showSetting">
							<span class="icon iconfont icon-setting" style="font-size: 20px"></span>
						</div>

          </div>
        </div>


      </div>
    </div>
    <div class="content-box">
      <inbox-plugin-session 
        v-if="uiStore.viewCode === 1"
        @chatItemClick="onChatItemClick"
      ></inbox-plugin-session>
      <inbox-friend 
        v-if="uiStore.viewCode === 2"
        @showFriend="onFriendClick"
      ></inbox-friend>
      <inbox-group 
        v-if="uiStore.viewCode === 3"
        @groupClick="onGroupClick"
      ></inbox-group>
    </div>
    <setting :visible="showSettingDialog" @close="closeSetting()"></setting>
    <user-info
      v-show="uiStore.userInfo.show"
      :pos="uiStore.userInfo.pos"
      :user="uiStore.userInfo.user"
      @close="$store.commit('closeUserInfoBox')"
    ></user-info>
    <full-image
      :visible="uiStore.fullImage.show"
      :url="uiStore.fullImage.url"
      @close="$store.commit('closeFullImageBox')"
    ></full-image>
    <rtc-private-video ref="rtcPrivateVideo"></rtc-private-video>
    <rtc-group-video ref="rtcGroupVideo"></rtc-group-video>
  </div>
</template>

<script>
import HeadImage from "../components/common/HeadImage.vue";
import Setting from "../components/setting/Setting.vue";
import UserInfo from "../components/common/UserInfo.vue";
import FullImage from "../components/common/FullImage.vue";
import RtcPrivateVideo from "../components/rtc/RtcPrivateVideo.vue";
import RtcPrivateAcceptor from "../components/rtc/RtcPrivateAcceptor.vue";
import RtcGroupVideo from "../components/rtc/RtcGroupVideo.vue";
import InboxPluginSession from "./InboxPluginSession.vue";
import InboxFriend from "./InboxFriend.vue";
import InboxGroup from "./InboxGroup.vue";

export default {
  components: {
    HeadImage,
    Setting,
    UserInfo,
    FullImage,
    RtcPrivateVideo,
    RtcPrivateAcceptor,
    RtcGroupVideo,
    InboxPluginSession,
    InboxFriend,
    InboxGroup,
  },
  data() {
    return {
      showSettingDialog: false,
      lastPlayAudioTime: new Date().getTime() - 1000,
      isFullscreen: true,
      reconnecting: false,
    };
  },
  methods: {
    init() {
      this.$eventBus.$on("openPrivateVideo", (rctInfo) => {
        // 进入单人视频通话
        this.$refs.rtcPrivateVideo.open(rctInfo);
      });
      this.$eventBus.$on("openGroupVideo", (rctInfo) => {
        // 进入多人视频通话
        this.$refs.rtcGroupVideo.open(rctInfo);
      });

      this.$store
        .dispatch("load")
        .then(() => {
          // ws初始化
          this.$wsApi.connect(
            process.env.VUE_APP_WS_URL,
            sessionStorage.getItem("accessToken")
          );
          this.$wsApi.onConnect(() => {
            if (this.reconnecting) {
              this.onReconnectWs();
            } else {
              // 加载离线消息
              this.pullPrivateOfflineMessage(
                this.$store.state.chatStore.privateMsgMaxId
              );
              this.pullGroupOfflineMessage(
                this.$store.state.chatStore.groupMsgMaxId
              );
            }
          });
          this.$wsApi.onMessage((cmd, msgInfo) => {
            if (cmd == 2) {
              // 强制下线已禁用，忽略此命令
              console.log('[InboxPlugin] 收到强制下线命令（已禁用，忽略）');
            } else if (cmd == 3) {
              // 插入私聊消息
                this.handlePrivateMessage(msgInfo);
              
            } else if (cmd == 4) {
              // 插入群聊消息
              this.handleGroupMessage(msgInfo);
            } else if (cmd == 5) {
              // 处理系统消息
              this.handleSystemMessage(msgInfo);
            }
          });
          this.$wsApi.onClose((e) => {
            if (e.code != 3000) {
              // 断线重连
              this.reconnectWs();
            }
          });
        })
        .catch((e) => {
          console.log("初始化失败", e);
        });
    },
    reconnectWs() {
      // 记录标志
      this.reconnecting = true;
      // 重新加载一次个人信息，目的是为了保证网络已经正常且token有效
      this.$store
        .dispatch("loadUser")
        .then(() => {
          // 断线重连
          this.$message.error("连接断开，正在尝试重新连接...");
          this.$wsApi.reconnect(
            process.env.VUE_APP_WS_URL,
            sessionStorage.getItem("accessToken")
          );
        })
        .catch(() => {
          // 10s后重试
          setTimeout(() => this.reconnectWs(), 10000);
        });
    },
    onReconnectWs() {
      // 重连成功
      this.reconnecting = false;
      // 重新加载群和好友
      const promises = [];
      promises.push(this.$store.dispatch("loadFriend"));
      promises.push(this.$store.dispatch("loadGroup"));
      Promise.all(promises)
        .then(() => {
          // 加载离线消息
          this.pullPrivateOfflineMessage(
            this.$store.state.chatStore.privateMsgMaxId
          );
          this.pullGroupOfflineMessage(
            this.$store.state.chatStore.groupMsgMaxId
          );
          this.$message.success("重新连接成功");
        })
        .catch(() => {
          this.$message.error("初始化失败");
          this.onExit();
        });
    },
    pullPrivateOfflineMessage(minId) {
      this.$store.commit("loadingPrivateMsg", true);
      this.$http({
        url: "/message/private/pullOfflineMessage?minId=" + minId,
        method: "GET",
      }).catch(() => {
        this.$store.commit("loadingPrivateMsg", false);
      });
    },
    pullGroupOfflineMessage(minId) {
      this.$store.commit("loadingGroupMsg", true);
      this.$http({
        url: "/message/group/pullOfflineMessage?minId=" + minId,
        method: "GET",
      }).catch(() => {
        this.$store.commit("loadingGroupMsg", false);
      });
    },
    handlePrivateMessage(msg) {
      // 标记这条消息是不是自己发的
      msg.selfSend = msg.sendId == this.$store.state.userStore.userInfo.id;
      
      // 🔧 检查是否为终端消息：包含senderTerminal和targetTerminal字段的就是终端消息
      if (msg.senderTerminal !== undefined && msg.targetTerminal !== undefined) {
        console.log("[InboxPlugin] 🔧 接收到终端消息:", msg);
        // 设置终端消息标识
        msg.isTerminalChat = true;
        if(msg.targetTerminal===4){
          this.insertTerminalMessage(msg);
        }
        // 🔧 修复：终端消息也需要更新privateMsgMaxId
        if (msg.id && msg.id > this.$store.state.chatStore.privateMsgMaxId) {
          this.$store.commit('updatePrivateMsgMaxId', msg.id);
        }
        return;
      }
      
      // 好友id
      let friendId = msg.selfSend ? msg.recvId : msg.sendId;
      // 会话信息
      let chatInfo = {
        type: "PRIVATE",
        targetId: friendId,
      };
      // 消息加载标志
      if (msg.type == this.$enums.MESSAGE_TYPE.LOADING) {
        this.$store.commit("loadingPrivateMsg", JSON.parse(msg.content));
        return;
      }
      // 消息已读处理，清空已读数量
      if (msg.type == this.$enums.MESSAGE_TYPE.READED) {
        this.$store.commit("resetUnreadCount", chatInfo);
        return;
      }
      // 消息回执处理,改消息状态为已读
      if (msg.type == this.$enums.MESSAGE_TYPE.RECEIPT) {
        this.$store.commit("readedMessage", {
          friendId: msg.sendId,
        });
        return;
      }
      // 消息撤回
      if (msg.type == this.$enums.MESSAGE_TYPE.RECALL) {
        this.$store.commit("recallMessage", [msg, chatInfo]);
        return;
      }
      // 新增好友
      if (msg.type == this.$enums.MESSAGE_TYPE.FRIEND_NEW) {
        this.$store.commit("addFriend", JSON.parse(msg.content));
        return;
      }
      // 删除好友
      if (msg.type == this.$enums.MESSAGE_TYPE.FRIEND_DEL) {
        this.$store.commit("removeFriend", friendId);
        return;
      }
      // 单人webrtc 信令
      if (this.$msgType.isRtcPrivate(msg.type)) {
        this.$refs.rtcPrivateVideo.onRTCMessage(msg);
        return;
      }
      // 插入消息
      if (
        this.$msgType.isNormal(msg.type) ||
        this.$msgType.isTip(msg.type) ||
        this.$msgType.isAction(msg.type)
      ) {
        let friend = this.loadFriendInfo(friendId);
        this.insertPrivateMessage(friend, msg);
      }
    },
    insertPrivateMessage(friend, msg) {
      let chatInfo = {
        type: "PRIVATE",
        targetId: friend.id,
        showName: friend.nickName,
        headImage: friend.headImage
      };
      // 打开会话
      this.$store.commit("openChat", chatInfo);
      // 插入消息
      this.$store.commit("insertMessage", [msg, chatInfo]);
      // 播放提示音
      if (
        !msg.selfSend &&
        this.$msgType.isNormal(msg.type) &&
        msg.status != this.$enums.MESSAGE_STATUS.READED
      ) {
        this.playAudioTip();
      }
    },
    
    // 🔧 修正：终端消息插入方法（目标终端模式）
    insertTerminalMessage(msg) {
      try {
        const userInfo = this.$store.state.userStore.userInfo;
        if (!userInfo || !userInfo.id) {
          console.error("[InboxPlugin] 用户信息未加载，无法处理终端消息");
          return;
        }
        
        // 🔧 修正：使用发送端作为会话标识（目标终端模式）
        const senderTerminal = msg.senderTerminal;
        const targetTerminal = msg.targetTerminal || this.getCurrentTerminal(); // 如果没有targetTerminal，使用当前终端
        const currentTerminal = this.getCurrentTerminal();
        
        // 🔧 关键修复：确保终端消息的selfSend字段正确设置
        msg.selfSend = msg.senderTerminal === currentTerminal;
        
        // 🔧 补充缺失的targetTerminal字段
        if (!msg.targetTerminal) {
          msg.targetTerminal = currentTerminal;
        }
        
        console.log(`🔧 [InboxPlugin] 终端消息: ${this.getTerminalName(senderTerminal)}端→${this.getTerminalName(targetTerminal)}端, selfSend=${msg.selfSend}`);
        
        // 🔧 修正：创建发送端会话信息（在目标端显示为"发送端会话"）
        const chatInfo = {
          type: "PRIVATE",
          targetId: `${userInfo.id}_${senderTerminal}`,  // 使用发送端标识
          showName: `${userInfo.nickName}(${this.getTerminalName(senderTerminal)}端)`,
          headImage: this.getTerminalIcon(senderTerminal),
          isTerminalChat: true,  // 使用新的标识
          senderTerminal: senderTerminal,  // 记录发送端
          targetTerminal: targetTerminal
        };
        
        // 🔧 修正：设置消息的发送者昵称（显示发送端信息）
        msg.sendNickName = `${userInfo.nickName}(${this.getTerminalName(senderTerminal)}端)`;
        
        // 使用统一的会话管理流程
        this.$store.commit("openChat", chatInfo);
        this.$store.commit("insertMessage", [msg, chatInfo]);
        
        console.log(`✅ [InboxPlugin] 终端消息已插入到 ${this.getTerminalName(senderTerminal)}端 会话`);
        
        // 播放提示音（接收到其他终端的消息时）
        if (!msg.selfSend && this.$msgType.isNormal(msg.type) &&
            msg.status != this.$enums.MESSAGE_STATUS.READED) {
          this.playAudioTip();
        }
      } catch (error) {
        console.error("[InboxPlugin] 处理终端消息失败:", error, msg);
      }
    },
    
    // 🔧 新增：获取终端名称的工具方法
    getTerminalName(terminal) {
      const terminalNames = {
        0: "傻蛋网页",
        1: "傻蛋精灵App",
        2: "我的电脑",
        3: "我的云电脑",
        4: "傻蛋浏览器",
        5: "MCP",
        6: "我的小龙虾"
      };
      return terminalNames[terminal] || "未知";
    },

    // 🔧 新增：获取终端图标的工具方法
    getTerminalIcon(terminal) {
      const terminalIcons = {
        0: "🌐",
        1: "📱",
        2: "💻",
        3: "🖥️",
        4: "🔌",
        5: "🤖",
        6: "🦞"
      };
      return terminalIcons[terminal] || "❓";
    },

    // 🔧 新增：获取当前终端类型
    getCurrentTerminal() {
      // 根据环境判断当前终端类型
      
      return 4; // 默认Web
    },
    
    handleGroupMessage(msg) {
      // 标记这条消息是不是自己发的
      msg.selfSend = msg.sendId == this.$store.state.userStore.userInfo.id;
      let chatInfo = {
        type: "GROUP",
        targetId: msg.groupId,
      };
      // 消息加载标志
      if (msg.type == this.$enums.MESSAGE_TYPE.LOADING) {
        this.$store.commit("loadingGroupMsg", JSON.parse(msg.content));
        return;
      }
      // 消息已读处理
      if (msg.type == this.$enums.MESSAGE_TYPE.READED) {
        // 我已读对方的消息，清空已读数量
        this.$store.commit("resetUnreadCount", chatInfo);
        return;
      }
      // 消息回执处理
      if (msg.type == this.$enums.MESSAGE_TYPE.RECEIPT) {
        // 更新消息已读人数
        let msgInfo = {
          id: msg.id,
          groupId: msg.groupId,
          readedCount: msg.readedCount,
          receiptOk: msg.receiptOk,
        };
        this.$store.commit("updateMessage", [msgInfo, chatInfo]);
        return;
      }
      // 消息撤回
      if (msg.type == this.$enums.MESSAGE_TYPE.RECALL) {
        this.$store.commit("recallMessage", [msg, chatInfo]);
        return;
      }
      // 新增群
      if (msg.type == this.$enums.MESSAGE_TYPE.GROUP_NEW) {
        this.$store.commit("addGroup", JSON.parse(msg.content));
        return;
      }
      // 删除群
      if (msg.type == this.$enums.MESSAGE_TYPE.GROUP_DEL) {
        this.$store.commit("removeGroup", msg.groupId);
        return;
      }
      // 群视频信令
      if (this.$msgType.isRtcGroup(msg.type)) {
        this.$nextTick(() => {
          this.$refs.rtcGroupVideo.onRTCMessage(msg);
        });
        return;
      }
      // 插入群聊消息
      if (
        this.$msgType.isNormal(msg.type) ||
        this.$msgType.isTip(msg.type) ||
        this.$msgType.isAction(msg.type)
      ) {
        let group = this.loadGroupInfo(msg.groupId);
        this.insertGroupMessage(group, msg);
      }
    },
    insertGroupMessage(group, msg) {
      let chatInfo = {
        type: "GROUP",
        targetId: group.id,
        showName: group.showGroupName,
        headImage: group.headImageThumb,
      };
      // 打开会话
      this.$store.commit("openChat", chatInfo);
      // 插入消息
      this.$store.commit("insertMessage", [msg, chatInfo]);
      // 播放提示音
      if (
        !msg.selfSend &&
        msg.type <= this.$enums.MESSAGE_TYPE.VIDEO &&
        msg.status != this.$enums.MESSAGE_STATUS.READED
      ) {
        this.playAudioTip();
      }
    },
    handleSystemMessage(msg) {
      // 用户被封禁
      if (msg.type == this.$enums.MESSAGE_TYPE.USER_BANNED) {
        this.$wsApi.close(3000);
        this.$alert(
          "您的账号已被管理员封禁,原因:" + msg.content,
          "账号被封禁",
          {
            confirmButtonText: "确定",
            callback: (action) => {
              this.onExit();
            },
          }
        );
        return;
      }
    },
    onExit() {
      this.$wsApi.close(3000);
      sessionStorage.removeItem("accessToken");
      // 🔥 同时清理 localStorage 和其他 sessionStorage
      sessionStorage.removeItem('refreshToken');
      sessionStorage.removeItem('tokenKey');
      localStorage.removeItem('userInfo');
      location.href = "/";
    },
    playAudioTip() {
      // 离线消息不播放铃声
      if (this.$store.getters.isLoading()) {
        return;
      }
      // 防止过于密集播放
      if (new Date().getTime() - this.lastPlayAudioTime > 1000) {
        this.lastPlayAudioTime = new Date().getTime();
        let audio = new Audio();
        let url = require(`@/assets/audio/tip.wav`);
        audio.src = url;
        audio.play();
      }
    },
    showSetting() {
      this.showSettingDialog = true;
    },
    switchUi(code) {
      this.$store.commit("changeViewCode", code);
    },
    closeSetting() {
      this.showSettingDialog = false;
    },
    loadFriendInfo(id) {
      if(String(id).includes('_')){
				id = String(id).split('_')[0];
			}
      let friend = this.$store.getters.findFriend(id);
      if (!friend) {
        // 🔧 修复：如果是当前用户自己，返回用户自己的信息
        const currentUser = this.$store.state.userStore.userInfo;
        if (currentUser && currentUser.id == id) {
          friend = {
            id: id,
            nickName: currentUser.nickName || "我",
            showNickName: currentUser.nickName || "我",
            headImage: currentUser.headImageThumb || currentUser.headImage || "",
          };
        } else {
          // 其他未知用户
        friend = {
          id: id,
            nickName: "未知用户",
          showNickName: "未知用户",
          headImage: "",
        };
        }
      }
      return friend;
    },
    loadGroupInfo(id) {
      let group = this.$store.getters.findGroup(id);
      if (!group) {
        group = {
          id: id,
          showGroupName: "未知群聊",
          headImageThumb: "",
        };
      }
      return group;
    },
    // 新增方法：触发切换到聊天视图
    onChatItemClick(chatData) {
      // 触发父组件的事件，切换到聊天视图
      this.$emit('showChat', chatData);
    },
    onFriendClick(friendData) {
      // 触发父组件的事件，切换到好友详情视图
      this.$emit('showFriend', friendData);
    },
    onGroupClick(groupData) {
      // 构造聊天数据
      let chatData = {
        type: "GROUP",
        targetId: groupData.id,
        showName: groupData.showGroupName,
        headImage: groupData.headImageThumb,
      };
      this.$emit('showChat', chatData);
    },
  },
  computed: {
    uiStore() {
      return this.$store.state.uiStore;
    },
    unreadCount() {
      let unreadCount = 0;
      let chats = this.$store.state.chatStore.chats;
      chats.forEach((chat) => {
        if (!chat.delete) {
          unreadCount += chat.unreadCount;
        }
      });
      return unreadCount;
    },
  },
  watch: {
    unreadCount: {
      handler(newCount, oldCount) {
        let tip = newCount > 0 ? `${newCount}条未读` : "";
        this.$elm.setTitleTip(tip);
      },
      immediate: true,
    },
  },
  mounted() {
    this.init();
  },
  // 添加activated钩子，当组件重新显示时触发
  activated() {
    console.log('InboxPlugin组件重新激活');
    // 刷新聊天列表数据
    this.$nextTick(() => {
      this.$store.commit('refreshChats');
    });
  },
  // 添加deactivated钩子，当组件被隐藏时触发
  deactivated() {
    console.log('InboxPlugin组件被隐藏');
  },
  unmounted() {
    console.log("InboxPlugin组件卸载")
    // 只有在真正卸载时才关闭WebSocket连接
    if (this.$wsApi) {
      this.$wsApi.close();
    }
  },
};
</script>

<style scoped lang="scss">
.home-page {
  height: 100vh;
  justify-content: center;
  align-items: center;

  overflow: hidden;
  background: var(--im-color-primary-light-9);
  background-color: #f6f6f6;
  //background-image: url('../assets/image/background.jpg');


  .navi-bar {
    --icon-font-size: 22px;
    width: var(--width);
    background: var(--im-color-primary-light-1);
    padding: 10px 8px;  /* 调整内边距适应水平布局 */

    .top{
      margin-left: auto;
    }

    .navi-bar-box {
      display: flex;

      justify-content: space-between;
      align-items: center;  /* 垂直居中 */

      .botoom {
        margin-bottom: 0;  /* 移除底部边距 */
      }
    }

    .menu {

      display: flex;

      justify-content: center;
      align-content: center;

      .menu-item {
        margin-bottom: 0;  /* 移除底部边距 */
        margin-right: 12px;  /* 改为右侧边距 */
      }
    }

    .user-head-image {
      display: flex;
      justify-content: center;
    }

    .menu {
      //margin-top: 10px;
      display: flex;

      justify-content: center;
      align-content: center;

      .link {
        text-decoration: none;
      }

      .router-link-active .menu-item {
        color: #fff;
        background: var(--im-color-primary-light-2);
      }

      .link:not(.router-link-active) .menu-item:hover {
        color: var(--im-color-primary-light-7);
      }

      .menu-item {
        position: relative;
        color: var(--im-color-primary-light-4);
        width: var(--width);

        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 12px;

        .icon {
          font-size: var(--icon-font-size);
        }

        .unread-text {
          position: absolute;
          background-color: var(--im-color-danger);
          left: 28px;
          top: 8px;
          color: white;
          border-radius: 30px;
          padding: 0 5px;
          font-size: var(--im-font-size-smaller);
          text-align: center;
          white-space: nowrap;
          border: 1px solid #f1e5e5;
        }
      }
    }

    .botoom-item {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 12px;
      width: 100%;
      padding: 5px;
      cursor: pointer;
      color: var(--im-color-primary-light-4);
      font-size: var(--icon-font-size);

      .icon {
        font-size: var(--icon-font-size);
      }

      &:hover {
        font-weight: 600;
        color: var(--im-color-primary-light-7);
      }
    }
  }

  .content-box {
    flex: 1;
    padding: 0;
    background-color: #fff;
    text-align: center;
  }
}
</style>